import React, { FC, useEffect, useState } from 'react';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import EmployeeRow from './EmployeeRow';
import EmployeeRowLoader from './components/EmployeeRowLoader';
import EmployeeRowError from './components/EmployeeRowError';
import useEmployeeStats, { GetEmployeeStatsReponse } from '../../hooks/useEmployeeStats';

interface Props {
  employeeId: LegacyEmployee['id'];
  startDate?: string;
  endDate?: string;
}

const EmployeeRowContainer: FC<Props> = ({ employeeId, startDate, endDate }) => {
  const { removeEmployeeId, fetchEmployeeStats } = useEmployeeStats();
  const [employee, setEmployee] = useState<LegacyEmployee>();
  const [stats, setStats] = useState<GetEmployeeStatsReponse>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string>();

  useEffect(() => {
    if (startDate && endDate) {
      setLoading(true);

      fetchEmployeeStats(employeeId, startDate, endDate)
        .then((response) => {
          const { employee, ...stats } = response;
          setEmployee(employee);
          setStats(stats);
          setLoading(false);
        })
        .catch((error) => {
          setError(error.message);
          setLoading(false);
        });
    }
  }, [employeeId, startDate, endDate]);

  const handleRemoveRow = () => {
    removeEmployeeId(employeeId);
  };

  if (loading) {
    return <EmployeeRowLoader />;
  }

  if (error || !employee || !stats) {
    return <EmployeeRowError error={error ? error : 'Erreur lors du chargement des données'} />;
  }

  return <EmployeeRow onRemoveRow={handleRemoveRow} employee={employee} stats={stats} />;
};

export default React.memo(EmployeeRowContainer);
